<template>
	<!-- TODO 可能需要显示多次退款的明细信息-->
	<v-card>
		<v-card-title>退款退货</v-card-title>
		<v-card-text>
			<div class="d-flex flex-row align-center">
				<date-picker
					v-model="form.date"
					label="选择退款日期，不可修改"
					:xxdisabled="form.id ? true : false"
				></date-picker>
			</div>
			<v-chip color="warning">合计{{ totalRefundQty }} 克 - {{ totalRefundAmt }}元</v-chip>
			<v-alert v-if="errors && errors.length > 0" type="error">
				<v-list>
					<v-list-item v-for="error in Object.values(errors)" :key="error">
						{{ error }}
					</v-list-item>
				</v-list>
			</v-alert>
			<v-table>
				<thead>
					<tr>
						<th>名称</th>
						<th>价格/kg</th>
						<th>订单数量/g</th>
						<th>已退/g</th>
						<th>退货数量/g</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in items" :key="item.id">
						<td>{{ item.bean_name }}</td>
						<td>{{ item.price }}</td>
						<td>{{ item.qty }}</td>
						<td>{{ refundqtyMap[item.id] }}</td>
						<td>
							<v-text-field
								v-model.number="refundqty[item.id]"
								:id="`refundqty` + item.id"
								style="max-width: 10rem"
								type="number"
								min="0"
								step="1"
								@input="validateNumberInput($event, 'refundqty', item.id)"
							></v-text-field>
						</td>
					</tr>
				</tbody>
			</v-table>
			<v-table>
				<thead>
					<tr>
						<th>付款类型</th>
						<th>付款金额</th>
						<th>已退金额</th>
						<th>退货金额</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in payment.items" :key="item.id">
						<td>{{ item.type }}({{ item.ids }})</td>
						<td>{{ item.amt }}</td>
						<td>{{ refundamtMap[item.id] }}</td>
						<td>
							<v-text-field
								v-model.number="refundamt[item.id]"
								:id="`refundamt` + item.id"
								style="max-width: 10rem"
								type="number"
								min="0"
								step="0.01"
								@input="validateNumberInput($event, 'refundamt', item.id)"
							></v-text-field>
						</td>
					</tr>
				</tbody>
			</v-table>

			<v-btn color="primary" @click="confirm" v-if="totalRefundQty > 0 || totalRefundAmt > 0">确认退款</v-btn>

			<v-textarea
				rows="2"
				variant="outlined"
				v-model="form.memo"
				:error-messages="errors.memo"
				label="备注"
			></v-textarea>

			<slot name="actions" :object="form"></slot>
		</v-card-text>
	</v-card>
</template>

<script>
import DatePicker from '../common/DatePicker.vue'
import { clone } from 'lodash-es'

export default {
	name: 'OrderRefundForm',
	components: {
		DatePicker
	},
	props: {
		orderNo: { type: [String, Number], default: () => ({}) },
		errors: { type: Object, default: () => ({}) }
	},
	data() {
		return {
			form: {},
			order: null,
			items: [],
			payment: {},
			refunds: [],
			refundqty: {}, // {item.id: refundqty}
			refundamt: {} // {paymentitem.id: refundamt}
		}
	},
	mounted() {
		this.$api.order.getById(this.orderNo, (order) => {
			this.order = order
			this.form = {
				order_id: order.id //order.sn
			}
			this.$api.order.getItems(order.id, (items) => (this.items = items))
			this.$api.order.getPayment(order.id, (payment) => (this.payment = payment))
			this.$api.order.getRefunds(order.id, (refunds) => (this.refunds = refunds))
		})
	},
	computed: {
		totalRefundAmt() {
			return Object.values(this.refundamt).reduce((acc, cur) => acc + cur, 0)
		},
		totalRefundQty() {
			return Object.values(this.refundqty).reduce((acc, cur) => acc + cur, 0)
		},
		refundqtyMap() {
			let map = {}
			for (let refund of this.refunds) {
				for (let item of refund.items) {
					if (!map[item.order_item_id]) {
						map[item.order_item_id] = 0
					}
					map[item.order_item_id] += item.qty
				}
			}
			return map
		},
		refundamtMap() {
			let map = {}
			for (let refund of this.refunds) {
				for (let item of refund.amts) {
					if (!map[item.order_payment_item_id]) {
						map[item.order_payment_item_id] = 0
					}
					map[item.order_payment_item_id] += item.amt
				}
			}
			return map
		}
	},
	watch: {
		order: {
			//当发生外部变化时
			handler(val) {
				if (val) {
					this.form = clone(val)
				}
			},
			deep: true
		}
	},
	methods: {
		calcPricePerGram(bean, user) {
			return bean.cprice / 1000 //LATER 现在只是返回零售价
		},
		validateNumberInput(event, type, id) {
			const value = event.target.value
			// 只允许数字、小数点和负号
			const cleanValue = value.replace(/[^0-9.-]/g, '')

			// 确保只有一个小数点
			const parts = cleanValue.split('.')
			if (parts.length > 2) {
				event.target.value = parts[0] + '.' + parts.slice(1).join('')
			} else {
				event.target.value = cleanValue
			}

			// 更新对应的数据 (Vue 3 不需要 $set)
			if (type === 'refundqty') {
				this.refundqty[id] = parseFloat(cleanValue) || 0
			} else if (type === 'refundamt') {
				this.refundamt[id] = parseFloat(cleanValue) || 0
			}
		},
		confirm() {
			this.$confirm(`确定要退款吗？`).then((r) => {
				if (r) {
					let items = []
					for (let item of this.items) {
						if (this.refundqty[item.id] > 0)
							items.push({
								order_item_id: item.id,
								qty: this.refundqty[item.id]
							})
					}
					let amts = []
					for (let item of this.payment.items) {
						if (this.refundamt[item.id] > 0)
							amts.push({
								order_payment_item_id: item.id,
								amt: this.refundamt[item.id]
							})
					}
					this.$emit('confirm', {
						order_id: this.order.id,
						date: this.form.date,
						totalqty: parseInt(this.totalRefundQty),
						totalamt: parseFloat(this.totalRefundAmt),
						items,
						amts
					})
				}
			})
		}
	}
}
</script>
